import React from 'react';
import { Outlet } from 'react-router-dom';

const MyClientsLayout: React.FC = () => {
  return <Outlet />
  ;
};

export default MyClientsLayout;
